import { applyMiddleware, combineReducers, compose, createStore as _createStore } from 'redux';
// tslint:disable-next-line:match-default-export-name
import thunkMiddleware, { ThunkMiddleware } from 'redux-thunk';

import { IApplicationState, TReduxActions, IReduxStore, IThunkContext, TFilterActions } from '../../types/redux';
import { IPageState } from '../../types/page';
import {
  favoriteEntityTypeReducer,
  dealTypeReducer,
  orderFieldReducer,
  showFiltersModalReducer,
} from '../../reducers/filters';
import { IFiltersState } from '../../types/filters';
import { resultsReducer } from '../../reducers/results';
import { notificationsReducer } from '../../reducers/notifications';
import { TUser } from '../../api/getUser';
import { authorizationTrapReducer } from '../../reducers/authorization_trap';
import { printReducer } from '../../reducers/print';
import { removeAllConfirmReducer } from '../../reducers/removeAllConfirm';
import { countsReducer } from '../../reducers/counts';
import { complainReducer } from '../../reducers/complain';
import { selectedReducer } from '../../reducers/selected';
import { configReducer } from '../../reducers/config/reducer';
import { IAbUseExperiment } from '../../types/abUseExperiment';
import { foldersReducer } from '../../reducers/folders/reducer';
import { favoritesAssignWidgetReducer } from '@cian/favorites-assign-widget';

let storeReminder: IReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param preloadedState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(context: IThunkContext, preloadedState: IApplicationState, debugEnabled?: boolean) {
  const reducers = combineReducers<IApplicationState, TReduxActions>({
    config: configReducer,
    abUseExperiments: (state: IAbUseExperiment[] = preloadedState.abUseExperiments) => state,
    filters: combineReducers<IFiltersState, TFilterActions>({
      dealType: dealTypeReducer,
      favoriteEntityType: favoriteEntityTypeReducer,
      orderField: orderFieldReducer,
      showFiltersModal: showFiltersModalReducer,
    }),
    results: resultsReducer,
    folders: foldersReducer,
    notifications: notificationsReducer,
    page: (state: IPageState = preloadedState.page) => state,
    user: (state: TUser = preloadedState.user) => state,
    authorizationTrap: authorizationTrapReducer,
    print: printReducer,
    removeAllConfirm: removeAllConfirmReducer,
    counts: countsReducer,
    complain: complainReducer,
    selected: selectedReducer,
    favoritesAssignWidget: favoritesAssignWidgetReducer,
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(
    applyMiddleware(
      thunkMiddleware.withExtraArgument(context) as ThunkMiddleware<IApplicationState, TReduxActions, IThunkContext>,
    ),
  );

  const createStore = () => _createStore(reducers, preloadedState, storeEnchancers);

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
